import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c197a4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-8 mb-3" }
const _hoisted_3 = { class: "dx-item-content dx-toolbar-item-content" }
const _hoisted_4 = {
  role: "group",
  class: "dx-buttongroup dx-widget",
  tabindex: "0"
}
const _hoisted_5 = { class: "dx-buttongroup-wrapper dx-widget dx-collection" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronprev" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-shape-standard dx-scheduler-navigator-caption",
  role: "button",
  "aria-label": ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronnext" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check" }, null, -1))
const _hoisted_12 = { class: "row" }

import { ref, computed, onMounted } from 'vue';
import moment from 'moment-timezone';
import { useStore } from 'vuex';
import { Booking, Inspector } from "@/models";
import BookingDetailModal from "@/components/modals/BookingDetailModal.vue";
import RevisitDetailModal from "@/components/modals/RevisitDetailModal.vue";
import TimeCellTemplate from "./TimeCellTemplate.vue";
import BookingTemplate from "./BookingTemplate.vue";
import InspectorTemplate from "./InspectorTemplate.vue";

import { DxDateBox } from "devextreme-vue/date-box";
import {
  DxScheduler,
  DxResource,
  DxScrolling,
} from "devextreme-vue/scheduler";

// Define store

export default /*#__PURE__*/_defineComponent({
  __name: 'PiScheduler',
  setup(__props) {

const store = useStore();

// Define refs and reactive properties
const editing = ref({
  allowAdding: false,
  allowDeleting: false,
  allowUpdating: false,
  allowResizing: false,
  allowDragging: false,
});
const appointmentdragging = ref({ autoScroll: false });
const showtimeline = ref(true);
const timelineposition = ref("125.5px");
const loggedininspector = ref<Inspector | undefined>(new Inspector());
const height = ref(window.innerHeight);
const width = ref(window.innerWidth);
const _currentdate = ref<Date>(new Date());

const bookingDetailModal = ref(null);
const revisitDetailModal = ref(null);
const email = computed(() => store.getters['auth/email']);
const bookings = computed(() => store.getters['diary/list']);
const getBookings = async (payload?: { date?: string; inspectorid?: string }): Promise<Booking[]> => {
  return await store.dispatch('diary/getBookings', payload);
};

const getInspectorByEmail = async (email: string): Promise<Inspector> => {
  return await store.dispatch('diary/getInspectorByEmail', email);
};

const setCurrentdate = (currentdate: Date): void => {
  getBookings({ date: moment(currentdate).format("DD-MM-YYYY"), inspectorid: loggedininspector.value.id });
  store.commit('diary/setCurrentdate', currentdate);
};

const onOptionChanged = (args: any) => {
  // if (args.name === "currentDate" && loggedininspector.value) {
  //   getBookings({ date: moment(args.value).format("DD-MM-YYYY"), inspectorid: loggedininspector.value.id });
  // }
};

const schedulerContentReady = (e: any) => {
  e.component.getWorkSpaceScrollable().option('showScrollbar', 'always');
  e.component.getWorkSpaceScrollable().option('useNative', 'true');
};

const onAppointmentClick = (e: any) => {
  e.cancel = true;
  if (e.appointmentData) {
    let booking: Booking = e.appointmentData;
    if(booking.subtype != Booking.PERSONAL) {
      if(booking.subtype === Booking.REVISIT) {
        const modal = revisitDetailModal.value as any;
        if (modal) {
          modal.init(booking, false);
          modal.show();
        }
      }
      else {
        const modal = bookingDetailModal.value as any;
        if (modal) {
          modal.init(booking);
          modal.show();
        }
      }
    }
  }
};

// Define computed properties
const currentdate = computed({
  get: () => _currentdate.value,
  set: (val: Date) => {
    let days = currentdatedifferencewithtoday(val);
    if (days < 8) {
      setCurrentdate(val);
    } else {
      const valmoment = moment(new Date()).utc().startOf("day");
      let adjusteddate = valmoment.add(7, 'days').toDate();
      setCurrentdate(adjusteddate);
    }
  }
});

const groups = computed(() => ["employeeId"]);
const employees = computed(() => [loggedininspector.value]);

const currentdatedifferencewithtoday = (val: Date) => {
  const todaymoment = moment(new Date()).utc().startOf('day');
  const currentmoment = moment(val).utc().startOf("day");
  let days = moment.duration(currentmoment.diff(todaymoment)).asDays();
  return days + 1;
};

const maxdate = computed(() => {
  const todaymoment = moment(new Date()).utc().startOf('day');
  return todaymoment.add(7, "days").toDate();
});

onMounted(async () => {
  loggedininspector.value = await getInspectorByEmail(email.value);
    if (loggedininspector.value) {
      getBookings({ date: moment(currentdate.value).format("DD-MM-YYYY"), inspectorid: loggedininspector.value.id });

      setInterval(() => {
        const now = new Date();
        const currentdatesameastoday = moment(currentdate.value).isSame(now, 'day');
        const hours = now.getHours();
        const hourswithincalendarbounds = (hours >= 7 && hours <= 21);
        showtimeline.value = currentdatesameastoday && hourswithincalendarbounds;
        if(showtimeline.value) {
          let currentTime = now.getTime();
          const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          const targetTime = new Date(today.getTime() + 7 * 60 * 60 * 1000);
          const epochValueUntilSevenAM = targetTime.getTime();
          currentTime = currentTime - epochValueUntilSevenAM;
          const minuteHeight = window.innerHeight * 0.011669 / 15;
          const currentMinutes = currentTime / 60000;
          let newposition = Math.round(currentMinutes * minuteHeight);
          newposition = newposition + 128.5;
          timelineposition.value = `${newposition}px`;
        }
      }, 6000);
    }
});

const prevdate = () => {
  _currentdate.value = moment(_currentdate.value)
    .utc()
    .subtract(1, "days")
    .toDate();
};

const nextdate = () => {
  _currentdate.value = moment(_currentdate.value).utc().add(1, "days").toDate();
};

const today = () => {
  _currentdate.value = moment().utc().toDate();
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-first-item dx-shape-standard dx-scheduler-navigator-previous",
                role: "button",
                "aria-label": "chevronprev",
                onClick: prevdate
              }, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(DxDateBox), {
                  modelValue: currentdate.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentdate).value = $event)),
                  "display-format": "EEEE dd MMMM yyyy",
                  type: "date",
                  "picker-type": "calendar",
                  "apply-value-mode": "instantly",
                  class: "pidatebox",
                  calendarOptions: {firstDayOfWeek:1},
                  max: maxdate.value
                }, null, 8, ["modelValue", "max"])
              ]),
              _createElementVNode("div", {
                class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-last-item dx-shape-standard dx-scheduler-navigator-next",
                role: "button",
                "aria-label": "chevronnext",
                onClick: nextdate
              }, _hoisted_10)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "col-4" }, [
        _createElementVNode("button", {
          class: "btn btn-light",
          title: "Today",
          onClick: today
        }, [
          _hoisted_11,
          _createTextVNode(" Today ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (showtimeline.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "timeline",
            style: _normalizeStyle({ 'top': timelineposition.value })
          }, null, 4))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_unref(DxScheduler), {
        id: "diary-scheduler",
        key: `diary-scheduler-${bookings.value.length}`,
        ref: "schedulerRef",
        class: "pischeduler",
        "time-zone": "Etc/UTC",
        "data-source": bookings.value,
        "current-date": currentdate.value,
        views: [],
        groups: groups.value,
        height: height.value - (height.value * 0.15),
        width: width.value - (width.value * 0.02),
        "show-all-day-panel": true,
        "all-day-panel-mode": 'hidden',
        "first-day-of-week": 1,
        "start-day-hour": 7,
        "end-day-hour": 21,
        "cell-duration": 15,
        "allow-adding": true,
        "allow-updating": false,
        editing: editing.value,
        "appointment-dragging": appointmentdragging.value,
        "show-current-time-indicator": false,
        "indicator-time": new Date(),
        "current-view": "day",
        "text-expr": "summary",
        "start-date-expr": "startdate",
        "end-date-expr": "enddate",
        "appointment-template": "bookingTemplate",
        "resource-cell-template": "inspectorTemplate",
        "time-cell-template": "timeCellTemplate",
        "cross-scrolling-enabled": false,
        "on-option-changed": onOptionChanged,
        "on-content-ready": schedulerContentReady,
        onAppointmentClick: onAppointmentClick
      }, {
        inspectorTemplate: _withCtx(({ data: employee }) => [
          _createVNode(InspectorTemplate, {
            employee: employee,
            pidiary: true
          }, null, 8, ["employee"])
        ]),
        timeCellTemplate: _withCtx(({ data: cellData }) => [
          _createVNode(TimeCellTemplate, { "cell-data": cellData }, null, 8, ["cell-data"])
        ]),
        bookingTemplate: _withCtx(({ data }) => [
          _createVNode(BookingTemplate, { "template-model": data }, null, 8, ["template-model"])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxResource), {
            "data-source": employees.value,
            "allow-multiple": false,
            label: "Inspectors",
            "field-expr": "employeeId"
          }, null, 8, ["data-source"]),
          _createVNode(_unref(DxScrolling), { mode: "standard" })
        ]),
        _: 1
      }, 8, ["data-source", "current-date", "groups", "height", "width", "editing", "appointment-dragging", "indicator-time"])),
      _createVNode(BookingDetailModal, {
        id: "pischedular-booking-detail-model",
        ref_key: "bookingDetailModal",
        ref: bookingDetailModal,
        editable: false
      }, null, 512),
      _createVNode(RevisitDetailModal, {
        id: "pischedular-revisit-detail-model",
        ref_key: "revisitDetailModal",
        ref: revisitDetailModal
      }, null, 512)
    ])
  ]))
}
}

})